<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      :clearable="clearable"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {Difficulty} from "@/modules/redactor/models/utils/Difficulty";

export default {
    name: "r-difficulty",
    props: {
        model: VueTypes.instanceOf(Difficulty),
        label: VueTypes.string.def("Difficulty"),
        clearable: VueTypes.bool.def(false)
    },
    computed: {
        value: {
            get: function () {
                return this.model;
            },
            set: function (value) {
                this.$emit("update:model", value);
            }
        },
        values() {
            return Difficulty.getValues();
        }
    }
}

</script>